/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /****************************************/
    // Qualifications On Entry Data View Model
    // Holds the applicant qualifications on entry data
    /****************************************/
    function QualificationsOnEntryViewModel() {

        // Self-Identification
        var self = this;

        /***  PROPERTIES ***/
        this.DataList = ko.observableArray();
        /***  PROPERTIES ***/

        /***  LIST DATA PROPERTIES ***/
        this.QualificationSittings = ko.observableArray();
        this.QualificationSubjects = ko.observableArray();
        this.QualificationTypes = ko.observableArray();
        /***  LIST DATA PROPERTIES ***/

        /*** SECTION PROPERTIES ***/
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.DataContainer = ko.observable("QualificationsContainer");
        this.Touched = ko.observable(false);
        this.IsRequired = ko.observable(false);
        this.DataLoadErrorCount = ko.observable(0);
        this.sectionVisibleByConfig = ko.observable(null);
        this.QualificationInformationText = ko.observable('');
        this.HesaQualificationTypeCode = ko.observable('');
        this.QualificationYearCompletedText = ko.observable('');
        this.QualificationFormTemplate = ko.observable('');
        this.QualificationYears = ko.observableArray();
        this.QualificationTypeText = ko.observable('');
        this.QualificationSummaryForm = ko.observable('');
        this.HesaQualificationTypeCodeValue = ko.observable();
        
        /*** SECTION PROPERTIES ***/
        
        sm.portal.vm.custom.setCustomLocalizeKey(self);
        /** ADD/EDIT LIST METHODS **/
        this.WorkingItem = ko.observable(new sm.portal.vm.QualificationOnEntryDataItem({
            QualificationSittings: this.QualificationSittings,
            QualificationSubjects: this.QualificationSubjects,
            QualificationTypes: this.QualificationTypes
        }));
        this.OriginalItem = ko.observable(new sm.portal.vm.QualificationOnEntryDataItem({
            QualificationSittings: this.QualificationSittings,
            QualificationSubjects: this.QualificationSubjects,
            QualificationTypes: this.QualificationTypes
        }));
        sm.portal.vm.custom.callCustomization('UpdateQualificationProperties', self);

        this.SaveWorkingChanges = function () {

            var workingItem = new sm.portal.vm.QualificationOnEntryDataItem({
                QualificationYear: self.WorkingItem().QualificationYear(),
                QualificationSittingID: self.WorkingItem().QualificationSittingID(),
                QualificationSitting: self.WorkingItem().QualificationSitting(),
                QualificationSubjectID: self.WorkingItem().QualificationSubjectID(),
                QualificationSubject: self.WorkingItem().QualificationSubject(),
                QualificationTypeID: self.WorkingItem().QualificationTypeID(),
                QualificationType: self.WorkingItem().QualificationType(),
                QualificationGrade: self.WorkingItem().QualificationGrade(),
                InEditMode: self.WorkingItem().InEditMode(),
                SectionRequired: self.IsRequired(),
                QualificationSittings: this.QualificationSittings,
                QualificationSubjects: this.QualificationSubjects,
                QualificationTypes: this.QualificationTypes
            });



            if (workingItem.QualificationSittingID()) {
                workingItem.QualificationSitting(self.GetQualificationSittingNameById(workingItem.QualificationSittingID()).name);
            }

            if (workingItem.QualificationSubjectID()) {
                workingItem.QualificationSubject(self.GetQualificationSubjectNameById(workingItem.QualificationSubjectID()).name);
            }

            if (workingItem.QualificationTypeID()) {
                workingItem.QualificationType(self.GetQualificationTypeNameById(workingItem.QualificationTypeID()).name);
            }

           var updatedWorkingItem =  sm.portal.vm.custom.callCustomization('SaveQualificationWorkingChanges', self,
                function(){
                    self.WorkingItem(new sm.portal.vm.QualificationOnEntryDataItem({
                        QualificationSittings: this.QualificationSittings,
                        QualificationSubjects: this.QualificationSubjects,
                        QualificationTypes: this.QualificationTypes
                    }));
                }            
            ); 
            
            if(updatedWorkingItem){
                workingItem = updatedWorkingItem;
            }
            

            if (workingItem.IsVMValid()) {

                if (!workingItem.InEditMode()) {
                    // This is an Add...
                    self.DataList.push(workingItem);
                    sm.portal.vm.custom.callCustomization('UpdateCompletedProp', self);
                } else {
                    // NOTE: Edits automatically bind back to the list (knockout is cool, huh?)
                    workingItem.InEditMode(false);
                    var customData = {
                        self : self,
                        workingItem : workingItem
                    }
                    sm.portal.vm.custom.callCustomization('UpdateWorkingItemOnSave', customData,
                        function(){
                            self.OriginalItem().QualificationSittingID(workingItem.QualificationSittingID());
                            self.OriginalItem().InEditMode(workingItem.InEditMode());   
                        }
                    
                    );
                    self.OriginalItem().QualificationYear(workingItem.QualificationYear());
                    self.OriginalItem().QualificationSittingID(workingItem.QualificationSittingID());
                    self.OriginalItem().QualificationSitting(workingItem.QualificationSitting());
                    self.OriginalItem().QualificationSubjectID(workingItem.QualificationSubjectID());
                    self.OriginalItem().QualificationSubject(workingItem.QualificationSubject());
                    self.OriginalItem().QualificationTypeID(workingItem.QualificationTypeID());
                    self.OriginalItem().QualificationType(workingItem.QualificationType());
                    self.OriginalItem().QualificationGrade(workingItem.QualificationGrade());
                }
                sm.portal.ui.comboBox();

                // hide the data entry view
                jQuery('.dataEntryView').hide();

                // show the display view with one item
                jQuery('.dataDisplayView').show();
                jQuery('.dataDisplayView ul.detailedList li').not('.noneAdded').show();
                sm.portal.vm.custom.callCustomization('FocusOnApplicationContentArea');
            }
        };

        this.GetQualificationSittingNameById = function (id) {

            for (var i = 0; i < self.QualificationSittings().length; i++) {
                if (self.QualificationSittings()[i].Value() === id) {
                    return self.QualificationSittings()[i].Text();
                }
            }
            return "";
        }

        this.GetQualificationSubjectNameById = function (id) {

            for (var i = 0; i < self.QualificationSubjects().length; i++) {
                if (self.QualificationSubjects()[i].Value() === id) {
                    return self.QualificationSubjects()[i].Text();
                }
            }
            return "";
        }

        this.GetQualificationTypeNameById = function (id) {

            for (var i = 0; i < self.QualificationTypes().length; i++) {
                if (self.QualificationTypes()[i].Value() === id) {
                    return self.QualificationTypes()[i].Text();
                }
            }
            return "";
        }

        this.PersistQualification = function (PersonID) {
            var customData = {
                self: self,
                personID : PersonID
            }
            sm.portal.vm.custom.callCustomization('PersistQualificationAditionalFields', customData);
        }

        this.CancelWorkingChanges = function () {
            
            sm.portal.vm.custom.callCustomization('QualificationsCancelWorkingChanges', self,
                function(){
                    self.WorkingItem(new sm.portal.vm.QualificationOnEntryDataItem({
                        QualificationSittings: this.QualificationSittings,
                        QualificationSubjects: this.QualificationSubjects,
                        QualificationTypes: this.QualificationTypes
                    }));
                }             
            );   


            //hide the display view
            jQuery('.dataEntryView').hide();

            // show the entry view
            jQuery('.dataDisplayView').show();
            sm.portal.vm.custom.callCustomization('FocusOnApplicationContentArea');
        };
        this.EditItem = function (data, event) {
            self.OriginalItem(data);
            var customData = {
                self: self,
                data: data
            }
            sm.portal.vm.custom.callCustomization('EditItemForQualifications', customData,
                function(){
                    self.WorkingItem(data);
                }            
            );
            
            self.WorkingItem().InEditMode(true);


            jQuery('.dataDisplayView').hide();
            jQuery('.dataEntryView').show();

            sm.portal.ui.comboBox();
            sm.portal.page.application.fieldHelp();
        };

        this.AddItem = function (data, event) {
            var tempWI = new QualificationOnEntryDataItem();
            var IsAddItem  = sm.portal.vm.custom.callCustomization('AddItemForQualification');
            
            if(!IsAddItem){
                tempWI.QualificationTypeID.rules()[0].params = false;
                tempWI.QualificationSubjectID.rules()[0].params = false;
            }
            
            self.WorkingItem(tempWI);
            sm.portal.page.application.fieldHelp();
        };

        this.RemoveItem = function (data, event) {
            var customData = {
                data : data,
                self : self
            }
            sm.portal.vm.custom.callCustomization('RemoveItemForQualification', customData,
                function(){
                    self.DataList.remove(function (item) {
                        return item.QualificationYear == data.QualificationYear &&
                            item.QualificationSittingID == data.QualificationSittingID &&
                            item.QualificationSubjectID == data.QualificationSubjectID &&
                            item.QualificationTypeID == data.QualificationTypeID &&
                            item.QualificationGrade == data.QualificationGrade;
                    });
                }
            );
            
            
        };
        /** ADD/EDIT LIST METHODS **/

        /***  COMPUTED PROPERTIES ***/
        this.AnythingPopulated = ko.computed(function () {
            if (this.DataList().length > 0) {
                for (var i = 0; i < this.DataList().length; i++) {
                    var dataItem = this.DataList()[i];
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.QualificationYear())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.QualificationSittingID())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.QualificationSitting())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.QualificationSubjectID())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.QualificationSubject())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.QualificationTypeID())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.QualificationType())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.QualificationGrade())) return true;
                    sm.portal.vm.custom.callCustomization('AnythingPopulatedForQualification', dataItem);
                    
                }
            }
            return false;
        }, this);

        if(sm.portal.utility.isNullOrEmpty(self.CompletedFlag)){
            this.Completed = ko.computed(function () {
                if (this.IsRequired()) {
                    return this.AnythingPopulated() && this.Touched();
                } else {
                    return this.Touched();
                }
            }, this);
        }


        /***  COMPUTED PROPERTIES ***/

        /*** SECTION METHODS ***/
        this.LoadModel = function (container) {
            // update application section configurations
            if (container && container.Payload && container.Payload.Config) {
                viewModel.SetSectionsConfigData("QualificationsOnEntry", container.Payload.Config);
                // To handle inclusion usecase
                var showSection = container.Payload.Config.ShowSection;
                !sm.portal.utility.isNullOrEmpty(showSection) && this.sectionVisibleByConfig(showSection);
            }

            if (container.Payload.ListData != undefined) {
                this.QualificationSittings = smapi.access.loadListItemModels(container.Payload.ListData.QualificationSittingOptions, this.QualificationSittings);
                this.QualificationSubjects = smapi.access.loadListItemModels(container.Payload.ListData.QualificationSubjectOptions, this.QualificationSubjects);
                this.QualificationTypes = smapi.access.loadListItemModels(container.Payload.ListData.QualificationTypeOptions, this.QualificationTypes);
            }
            var data = {
                container : container,
                self : self
            }
            sm.portal.vm.custom.callCustomization('LoadQualificationModel', data);

            if (container.Payload.QualificationResults != null) {

                for (var i = 0; i < container.Payload.QualificationResults.length; i++) {

                    var qualification = container.Payload.QualificationResults[i];

                    var newDataItem = new sm.portal.vm.QualificationOnEntryDataItem({
                        QualificationYear: qualification.QualificationYear,
                        QualificationSittingID: qualification.QualificationSittingID,
                        QualificationSitting: qualification.QualificationSitting,
                        QualificationSubjectID: qualification.QualificationSubjectID,
                        QualificationSubject: qualification.QualificationSubject,
                        QualificationTypeID: qualification.QualificationTypeID,
                        QualificationType: qualification.QualificationType,
                        QualificationGrade: qualification.QualificationGrade,
                        QualificationSittings: this.QualificationSittings,
                        QualificationSubjects: this.QualificationSubjects,
                        QualificationTypes: this.QualificationTypes
                    });

                    this.DataList.push(newDataItem);
                }

                var data = {
                    container : container,
                    self : self
                }
                sm.portal.vm.custom.callCustomization('LoadHesaQualificationProperties', data);
            }  

            this.DataLoading(false);
            this.DataLoaded(true);
            if (smapi.constant.applicationDebugFlag) { console.log('[QualificationsVM] Data Loaded'); }
        };

        this.GetModelData = function (blockui, applicationMID, personMID, callback) {
            
            if (!this.DataLoaded() && !this.DataLoading()) {
                this.DataLoading(true);
                if(!sm.portal.utility.isNullOrEmpty(viewModel.allCustomData())) {
                    self.LoadModel(viewModel.allCustomData().QualificationsOnEntry);
                    callback && callback(viewModel.allCustomData().QualificationsOnEntry);
                    return;
                }
                if (blockui) { jQuery.blockUI(); }
                var data = {
                    applicationMID : applicationMID,
                    personMID :personMID
                }
                var url;
                url = sm.portal.vm.custom.callCustomization('GetModelDataForQualification', data);
                if(!url){
                    url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/getapplicationsection?sectionName=qualifications&attemptmid={0}', applicationMID);                        
                }                
                
                jQuery.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,

                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        sm.portal.page.application.modelDataResponseHandler(self, data, applicationMID, personMID);
                        callback && callback(data);
                    },
                    error: function (jqXHR, exception) {
                        sm.portal.page.application.modelErrorHandler(self, jqXHR);
                        sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                        callback && callback();
                    }
                });
            } else {
                callback && callback();
            }
        };

        this.CheckInclusion = function (applicationMID, personMID) {
            
            var data = {
                applicationMID : applicationMID,
                personMID : personMID
            }
            var url;
            url = sm.portal.vm.custom.callCustomization('SetUrlForQualificationCheckInclusion', data);

            if(!url){
                url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/CheckApplicationSectionInclusion?sectionName=qualifications&attemptmid={0}', applicationMID);
            }

            jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {

                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                    if (data.Status == 'success') {
                        var result = container.Payload.InclusionResult;
                        var sectionsToAdd = Array();
                        var sectionsToRemove = Array();

                        console.log('Inclusion Result for Qualifications: ' + result);
                        switch (result) {
                            case "Included":
                                sectionsToAdd.push({ section: 'Qualifications', required: false });
                                break;
                            case "Required":
                                sectionsToAdd.push({ section: 'Qualifications', required: true });
                                break;
                            case "Exclude":
                                sectionsToRemove.push('Qualifications');
                                break;
                        }
                        console.log('Calling Maintain Sections');
                        if (self.sectionVisibleByConfig() === false && (result == "Included" || result == "Required")) {
                            sectionsToAdd = null; // If section is hidden by Configuration, don't add the section
                        }
                        viewModel.MaintainSections(sectionsToAdd, sectionsToRemove);
                    }
                },
                error: function (jqXHR, exception) {
                    sm.portal.page.application.modelErrorHandler(self, jqXHR);
                }
            });
        };

        this.BlockContainer = function () {
            jQuery("#" + self.DataContainer()).block({ message: sm.portal.utility.getResourceValue('Loading') });
        };
        this.UnBlockContainer = function () {
            jQuery("#" + self.DataContainer()).unblock();
            viewModel.SetFocus();
        };
        this.ProcessOnServer = function () {
            return true;
        };
        this.ExtractATO = function () {

            var atoList = Array();

            for (var i = 0; i < self.DataList().length; i++) {
                var dataListItem = self.DataList()[i];
                var ato = dataListItem.ExtractATO();
                atoList.push(ko.toJS(ato));
            }

            return atoList;
        };
        /*** SECTION METHODS ***/

        return self;
    };

    function QualificationOnEntryDataItem(options) {
        var defaults = {
            QualificationYear: '',
            QualificationSittingID: '',
            QualificationSubjectID: '',
            QualificationTypeID: '',
            QualificationGrade: '',
            InEditMode: false,
            ID: -1,
            GID: null,
            QualificationSittings: null,
            QualificationSubjects: null,
            QualificationTypes: null
        };
        sm.portal.vm.custom.callCustomization('SetDefaultPropsForQualificationDataItem', defaults);
        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        self.QualificationYear = ko.validatedObservable(settings.QualificationYear);
        self.QualificationSittingID = ko.validatedObservable(settings.QualificationSittingID);
        self.QualificationSitting = ko.validatedObservable(settings.QualificationSitting);
        self.QualificationSubjectID = ko.validatedObservable(settings.QualificationSubjectID);
        self.QualificationSubject = ko.validatedObservable(settings.QualificationSubject);
        self.QualificationTypeID = ko.validatedObservable(settings.QualificationTypeID);
        self.QualificationType = ko.validatedObservable(settings.QualificationType);
        self.QualificationGrade = ko.validatedObservable(settings.QualificationGrade);
        var data = {
            self : self,
            settings : settings
        }
        sm.portal.vm.custom.callCustomization('UpdateQualificationOnEntryDataItem', data);
        self.GID = ko.validatedObservable(settings.GID);
        self.ID = ko.validatedObservable(settings.ID);
        self.InEditMode = ko.observable(settings.InEditMode);

        if (settings.QualificationSittings == undefined || settings.QualificationSittings == null) {
            self.QualificationSittings = ko.observableArray();
        } else {
            self.QualificationSittings = settings.QualificationSittings;
        }

        if (settings.QualificationSubjects == undefined || settings.QualificationSubjects == null) {
            self.QualificationSubjects = ko.observableArray();
        } else {
            self.QualificationSubjects = settings.QualificationSubjects;
        }

        if (settings.QualificationTypes == undefined || settings.QualificationTypes == null) {
            self.QualificationTypes = ko.observableArray();
        } else {
            self.QualificationTypes = settings.QualificationTypes;
        }

        
        self.ExtractATO = function () {
            var response = sm.portal.vm.custom.callCustomization('ExtractATOForQualification',self );
            if(response){
                return response;
            }
            return new smapi.community.HesaQualificationResultModel({
                QualificationTypeID: self.QualificationTypeID(),
                QualificationYear: self.QualificationYear(),
                QualificationSubjectID: self.QualificationSubjectID(),
                QualificationSittingID: self.QualificationSittingID(),
                QualificationGrade: self.QualificationGrade(),
                ID: self.ID(),
                GID: self.GID()
            });
        }

        sm.portal.vm.custom.callCustomization('SubscribeHesaQualification', self);

        sm.portal.vm.custom.callCustomization('OverrideQualificationsValidations', self);   
        /*** VALIDATION METHODS ***/
        self.QualificationYear.extend({
            maxLength: {
                params: 4,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4')
            },
            min: {
                params: 1930,
                message: sm.portal.utility.getResourceValue("QualificationYearMin")
            },
            max: {
                params: 9999,
                message: sm.portal.utility.getResourceValue("QualificationYearMax")
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        self.QualificationSittingID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        self.QualificationSubjectID.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        self.QualificationTypeID.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        self.QualificationGrade.extend({
            maxLength: {
                params: 11,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '11')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {
            var isCompleted = this.IsVMValid();
            return isCompleted;
        }, this);
        /*** VALIDATION METHODS ***/

        return self;
    };

    jQuery.extend(true, sm.portal.vm, {
        QualificationsOnEntryViewModel: QualificationsOnEntryViewModel,
        QualificationOnEntryDataItem: QualificationOnEntryDataItem
    });

})(jQuery);